import { ErrorHandler, inject, provideAppInitializer } from '@angular/core';

import { AppComponent } from './app.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AboutComponent } from './about/about.component';
import { PricingComponent } from './pricing/pricing.component';
import { ReferencesComponent } from './references/references.component';
import { NavigationComponent } from './navigation/navigation.component';
import {DatePipe, DecimalPipe} from "@angular/common";
import { AdminComponent } from './admin/admin.component';
import { BroadcastSetupComponent } from './broadcast-setup/broadcast-setup.component';
import { BroadcastListComponent } from './broadcast-list/broadcast-list.component';
import { BroadcastDialogComponent } from './broadcast-dialog/broadcast-dialog.component';
import { BroadcastLayerModule } from "./broadcast-layer-module/broadcast-layer.module";
import { ScoreSheetComponent } from './score-sheet/score-sheet.component';
import { OffenseComponent } from './score-sheet/offense/offense.component';
import { PitchersComponent } from './score-sheet/pitchers/pitchers.component';
import { ConfigDialogComponent } from './broadcast-setup/config-dialog/config-dialog.component';
import * as Sentry from '@sentry/angular';
import { Router } from "@angular/router";
import { BroadcastControlComponent } from './broadcast-control/broadcast-control.component';
import { ConfirmDialogComponent } from './broadcast-control/confirm-dialog/confirm-dialog.component';
import { ResetDialogComponent } from './broadcast-control/reset-dialog/reset-dialog.component';
import { UndoDialogComponent } from './broadcast-control/undo-dialog/undo-dialog.component';
import { LowerThirdDialogComponent } from './broadcast-setup/lower-third-dialog/lower-third-dialog.component';
import { CustomTableDialogComponent } from './broadcast-setup/custom-table-dialog/custom-table-dialog.component';
import { LeagueDialogComponent } from './admin/league-dialog/league-dialog.component';
import { FileDialogComponent } from './admin/file-dialog/file-dialog.component';
import { UserOutputUrlComponent } from './user-output-url/user-output-url.component';

// This file is kept for backward compatibility and to provide services
// The application now uses standalone components bootstrapped in main.ts

// Export services and providers that can be used in main.ts
export const appProviders = [
    DatePipe,
    DecimalPipe,
    {
        provide: ErrorHandler,
        useValue: Sentry.createErrorHandler(),
    },
    {
        provide: Sentry.TraceService,
        deps: [Router],
    },
    provideAppInitializer(() => {
        // In Angular 19, inject() should be used directly without arguments
        return;
    })
];

// This class is kept for backward compatibility
export class AppModule { }
